import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const CorporateMeetings = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default CorporateMeetings;
